<template>
<div>


    <el-dialog title="Registrar uso del permiso" :visible.sync="registerFormVisible">
        <el-form :model="registerForm" ref="registerForm" @submit.prevent="handleAssignment" class="el-crud-form" size="mini" :rules="rules">
            <el-form-item label="Empleado" label-width="180px" label-position="right" class="no-bottom-space">
                CC {{ registerForm.permission.employee_id_number }} - {{ registerForm.permission.employee_name }}
            </el-form-item>
            <el-form-item label="Puesto" label-width="180px" label-position="right" class="no-bottom-space">
                {{ registerForm.permission.employee_title }}
            </el-form-item>
            <el-form-item label="Fecha permiso" label-width="180px" label-position="right" class="no-bottom-space">
                {{ permission_date }}
            </el-form-item>
            <el-form-item label="Desde - Hasta" label-width="180px" label-position="right" class="no-bottom-space">
                {{ permission_hours }}
            </el-form-item>
            <el-form-item label="Autorizador" label-width="180px" label-position="right" class="no-bottom-space">
                {{ registerForm.permission.updated_by }}
            </el-form-item>
            <el-form-item label="Observaciones" label-width="180px" label-position="right" class="no-bottom-space">
                {{ registerForm.permission.observations }}
            </el-form-item>
            <el-form-item label="Estado" label-width="180px" label-position="right" prop="status">
                <el-switch
                    style="display: block"
                    v-model="registerForm.permission.status"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="Registrado"
                    inactive-text="NO Registrado"
                    active-value="REG">
                </el-switch>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="registerFormVisible = false">Cancelar</el-button>
            <el-button type="primary" @click="handleRegister">Confirmar</el-button>
        </span>
    </el-dialog>


    <el-dialog title="Soportes del permiso" :visible.sync="uploadFilesFormVisible">
        <el-form :model="uploadFilesForm" ref="uploadFilesForm" @submit.prevent="handleUploadFile" class="el-crud-form" size="mini" :rules="rules">
            <el-form-item label="Empleado" label-width="180px" label-position="right" class="no-bottom-space">
                CC {{ uploadFilesForm.permission.employee_id_number }} - {{ uploadFilesForm.permission.employee_name }}
            </el-form-item>
            <el-form-item label="Puesto" label-width="180px" label-position="right" class="no-bottom-space">
                {{ uploadFilesForm.permission.employee_title }}
            </el-form-item>
            <el-form-item label="Fecha permiso" label-width="180px" label-position="right" class="no-bottom-space">
                {{ permission_date }}
            </el-form-item>
            <el-form-item label="Desde - Hasta" label-width="180px" label-position="right" class="no-bottom-space">
                {{ permission_hours }}
            </el-form-item>
            <el-form-item label="Autorizador" label-width="180px" label-position="right" class="no-bottom-space">
                {{ uploadFilesForm.permission.updated_by }}
            </el-form-item>
            <el-form-item label="Observaciones" label-width="180px" label-position="right" class="no-bottom-space">
                {{ uploadFilesForm.permission.observations }}
            </el-form-item>
            <el-form-item label="Estado" label-width="180px" label-position="right" class="no-bottom-space">
                {{ uploadFilesForm.permission.status }}
            </el-form-item>
            <el-form-item label="Archivos Cargados" label-width="180px" label-position="right" class="no-bottom-space">
                <el-table
                    :data="uploadFilesForm.permission.files"
                    v-loading="filesTableLoading"
                    :show-header="false"
                    style="width: 100%">
                    <el-table-column
                        prop="file_name">
                    </el-table-column>
                    <el-table-column
                        width="80"
                        align="center">
                        <template slot-scope="scope">
                            <a class="btn btn-default btn-sm" @click="downloadFile(scope.row.id)"><i class="fa fa-download"></i></a>
                            <a class="btn btn-default btn-sm" @click="removeFile(scope.row.id)"><i class="fa fa-times"></i></a>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="Nuevo Archivo" label-width="180px" label-position="right" prop="files">
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    :action="'/api/permissions/' + uploadFilesForm.permission.id + '/files'"
                    :auto-upload="false"
                    :headers="headers"
                    :on-success="uploadSuccess"
                    :multiple="false"
                    accept="application/pdf,image/png,image/jpeg"
                    name="support_file">
                    <el-button slot="trigger" size="mini" type="primary">Seleccionar archivo</el-button>
                    <el-button style="margin-left: 10px;" size="mini" type="success" @click="submitUpload">Subir archivo</el-button>
                    <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
                </el-upload>
            </el-form-item>
        </el-form>
    </el-dialog>

    <filters-form @filtersSubmited="onFiltersSubmited" />

    <el-crud :baseUrl="'/permissions'" 
        v-model="resource"
        :externalFiltersValid="filters.valid || false"
        :actions="['edit','delete']"
        :config="crudConfig"
        :validationRules="validationRules"
        name="permissions"
        @itemsFetched="handleItemsFetched"
        ref="crud">

        <template slot="crudTableActions">
            <a :disabled="downloadUrl == null" slot="top-buttons" class="btn btn-default btn-sm" @click="downloadReport()"><i class="fa fa-download"></i> Download</a>
        </template>

        <template slot="table">
            <el-table-column xsortable="custom"
                prop="employee_company_id_number"
                width="80"
                align="right"
                label="Código">
            </el-table-column>
            <el-table-column xsortable="custom"
                prop="employee_name"
                label="Empleado">
            </el-table-column>
            <el-table-column
                prop="datetime_from"
                label="Desde">
            </el-table-column>
            <el-table-column
                prop="datetime_to"
                label="Hasta">
            </el-table-column>
            <el-table-column
                prop="excuse_description"
                label="Tipo">
            </el-table-column>
            <el-table-column
                prop="status"
                align="center"
                label="Estado">
                <template slot-scope="scope">
                    <el-tag size="mini">{{ scope.row.status }}</el-tag>
                </template>
            </el-table-column>
            <!-- <el-table-column
                align="center"
                label="Justificada">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.justified" type="success" size="mini">Si</el-tag>
                    <el-tag v-else type="danger" size="mini">No</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="Remunerada">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.paid" type="success" size="mini">Si</el-tag>
                    <el-tag v-else type="danger" size="mini">No</el-tag>
                </template>
            </el-table-column> -->
            <el-table-column
                label="Obs.">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.observations != null && scope.row.observations.length > 5" class="item" effect="dark" :content="scope.row.observations" placement="top"><span>{{ scope.row.observations.substring(0, 5) }} ...</span></el-tooltip>
                    <span v-else>{{ scope.row.observations }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="Archivos">
                <template slot-scope="scope">{{scope.row.files.length}}</template>
            </el-table-column>
            <el-table-column
                width="120"
                prop="updated_by"
                label="Autorizador">
            </el-table-column>
            <el-table-column
                prop="updated_at"
                label="Fecha">
            </el-table-column>
        </template>

        <template slot="rowActions" slot-scope="scope">
            <el-button v-if="$auth.can(['permissions.register_usage']) && scope.row.status == 'APR'" size="small" type="primary" icon="el-icon-check" :plain="true"
            @click="handleCheck(scope.idx, scope.row)"></el-button>
            <el-button v-if="$auth.can(['permissions.issue'])" size="small" type="primary" icon="el-icon-document" :plain="true"
            @click="handleDocument(scope.idx, scope.row)"></el-button>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Empleado" label-width="140px" prop="employee_id">
                <el-select
                    v-model="resource.employee_id.value"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Nombre, Cédula o Código"
                    :remote-method="employeeSearch"
                    :loading="employee_loading">
                    <el-option
                        v-for="item in employees"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Fecha" label-width="140px" prop="date">
                <el-date-picker
                    v-model="resource.date.value"
                    :picker-options="{firstDayOfWeek:1}"
                    @change="datePickerChange"
                    placeholder="Fecha">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="Desde" label-width="140px" prop="time_from">
                <el-time-picker
                    v-model="time_from"
                    @change="timeFromPickerChange"
                    placeholder="Hora desde">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="Hasta" label-width="140px" prop="time_to">
                <el-time-picker
                    v-model="time_to"
                    @change="timeToPickerChange"
                    placeholder="Hora hasta">
                </el-time-picker>
                <el-radio-group size="mini" v-model="resource.end_record_date.value" @change="timeToPickerChange">
                    <el-radio-button v-model="resource.end_record_date.value" label="same_day">mismo día</el-radio-button>
                    <el-radio-button v-model="resource.end_record_date.value" label="next_day">día siguiente</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="Motivo" label-width="140px" :error="scope.errors.excuse_id" prop="excuse_id">
                <el-select v-model="resource.excuse_id" filterable placeholder="Seleccione" size="mini">
                    <el-option
                        v-for="item in excuses"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="Justificada" label-width="120px" :prop="resource.justified.value" :error="scope.errors.justified">
                <el-radio-group v-model="resource.justified.value">
                    <el-radio-button label="Si" size="small"></el-radio-button>
                    <el-radio-button label="No" size="small"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="Remunerada" label-width="120px" :prop="resource.paid.value" :error="scope.errors.paid">
                <el-radio-group v-model="resource.paid.value">
                    <el-radio-button label="Si" size="small"></el-radio-button>
                    <el-radio-button label="No" size="small"></el-radio-button>
                </el-radio-group>
            </el-form-item> -->
            <el-form-item label="Observaciones" label-width="140px" prop="observations">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="Observaciones"
                    v-model="resource.observations">
                </el-input>
            </el-form-item>
        </template>
    
    </el-crud>

</div>
</template>

<style>
table.details td {
    padding-left: 3px;
    padding-right: 3px;
    font-size: 11px;
    line-height: 1.3em;
    height: 15px;
}
.el-form-item--mini.el-form-item.no-bottom-space {
    margin-bottom: 0;
}
</style>

<script>
    import { mapGetters, mapActions } from "vuex";
    import filters_form from './reports/filters-form.vue';
    import el_crud from './el-crud.vue';
    export default {
        name: 'permissions',
        data() {
            const validateDate = (rule, value, callback) => {
                if (value.value == null) {
                    callback(new Error(rule._message));
                } else if (!this.$auth.can(['permissions.issue_outdated']) && moment().startOf('day').isAfter(moment(this.resource.date).startOf('day'))) {
                    callback(new Error('Debe seleccionar una fecha y hora en el futuro'));
                } else {
                    callback();
                }
            };
            const validateDateTimeFrom = (rule, value, callback) => {
                // const date = moment(this.resource.date.value);
                // const datetime = moment(this.resource.datetime_from.value).year(date.year()).month(date.month()).date(date.date());
                const datetime = moment(this.resource.datetime_from.value);
                if (this.resource.datetime_from.value == null) {
                    callback(new Error(rule._message));
                } else if (!this.$auth.can(['permissions.issue_outdated']) && moment().isAfter(datetime)) {
                    callback(new Error('Debe seleccionar una fecha y hora en el futuro'));
                } else if (this.resource.datetime_to.value != null && moment(this.resource.datetime_to.value).isSameOrBefore(datetime)) {
                    callback(new Error('La fecha de inicio debe ser menor a la de fin'));
                } else {
                    callback();
                }
            };
            const validateDateTimeTo = (rule, value, callback) => {
                // const date = moment(this.resource.date.value);
                // const datetime = moment(this.resource.datetime_to.value).year(date.year()).month(date.month()).date(date.date());
                const datetime = moment(this.resource.datetime_to.value);
                if (this.resource.datetime_to.value == null) {
                    callback(new Error(rule._message));
                } else if (!this.$auth.can(['permissions.issue_outdated']) && moment().isAfter(datetime)) {
                    callback(new Error('Debe seleccionar una fecha y hora en el futuro.'));
                } else if (this.resource.datetime_from.value != null && moment(this.resource.datetime_from.value).isSameOrAfter(datetime)) {
                    callback(new Error('La fecha de fin debe ser mayor a la de inicio'));
                } else {
                    callback();
                }
            };
            const validateStatus = (rule, value, callback) => {
                if (this.registerForm.permission.status != 'REG') {
                    callback(new Error(rule._message));
                } else {
                    callback();
                }
            };
            const canViewAllAreas = this.$auth.can(['permissions.delete']) || this.$auth.can(['permissions.register_usage']);
            return {
                canViewAllAreas,
                crudConfig:{
                    AddItemTitle: 'Agregar permiso',
                    EditItemTitle: 'Editar permiso',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el permiso. Desea continuar?',
                    actionsColumnWidth: 180,
                    actionsColumnAlign: 'right',
                },
                validationRules: {
                    employee_id: [
                        { required: true, message: 'Ingrese un usuario', trigger: 'change' },
                    ],
                    date: [
                        { validator: validateDate, required: true, _message: 'Seleccione una fecha', trigger: 'change' }
                    ],
                    time_from: [
                        { validator: validateDateTimeFrom, required: true, _message: 'Seleccione una hora de inicio', trigger: 'change' }
                    ],
                    time_to: [
                        { validator: validateDateTimeTo, required: true, _message: 'Seleccione una hora de fin', trigger: 'change' }
                    ],
                    excuse_id: [
                        { required: true, message: 'Seleccione un motivo', trigger: 'change' },
                    ],
                },
                time_from: null,
                time_to: null,
                resource: {
                    end_record_date: {
                        value: '',
                        setValue: (value) => {
                            // console.log(value);
                            this.resource.end_record_date.value = (value == 'next_day') ? value.end_record_date : 'same_day';
                        },
                        getValue: () => {
                            return this.resource.end_record_date.value;
                        }
                    },
                    employee_id: {
                        value: null,
                        setValue: (value) => {
                            if (value && value.employee) {
                                this.employees = [{label: value.employee.id_number + ' - ' + value.employee.last_name + ', ' + value.employee.first_name, value: value.employee.id}];
                            }
                            this.resource.employee_id.value = (value) ? value.employee_id : null;
                        }
                    },
                    date: {
                        value: '',
                        setValue: (value) => {
                            // this.resource.date.value = (value) ? value.date : null;
                            this.resource.date.value = (value) ? moment(value.datetime_from).format('YYYY-MM-DD') : null;
                        },
                        getValue: () => {
                            return moment(this.resource.date.value).format('YYYY-MM-DD');
                        }
                    },
                    datetime_from: {
                        value: '',
                        setValue: (value) => {
                            this.resource.datetime_from.value = (value) ? value.datetime_from : null;
                            this.time_from = (value) ? value.datetime_from : null; // moment().format('YYYY-MM-DD HH:mm:00');
                        },
                        getValue: () => {
                            return moment(this.resource.datetime_from.value).format('YYYY-MM-DD HH:mm:SS');
                        }
                    },
                    datetime_to: {
                        value: '',
                        setValue: (value) => {
                            this.resource.datetime_to.value = (value) ? value.datetime_to : null;
                            this.time_to = (value) ? value.datetime_to : null; // moment().format('YYYY-MM-DD HH:mm:00');
                        },
                        getValue: () => {
                            return moment(this.resource.datetime_to.value).format('YYYY-MM-DD HH:mm:SS');
                        }
                    },
                    excuse_id: null,
                    // justified: {
                    //     value: '',
                    //     setValue: (value) => {
                    //         this.resource.justified.value = (value && value.justified) ? 'Si' : 'No';
                    //     },
                    //     getValue: () => {
                    //         return this.resource.justified.value === 'Si';
                    //     }
                    // },
                    // paid: {
                    //     value: '',
                    //     setValue: (value) => {
                    //         this.resource.paid.value = (value && value.paid) ? 'Si' : 'No';
                    //     },
                    //     getValue: () => {
                    //         return this.resource.paid.value === 'Si';
                    //     }
                    // },
                    status: {
                        value: '',
                        setValue: (value) => {
                            this.resource.status.value = 'APR';
                        },
                        getValue: () => {
                            return 'APR';
                        }
                    },
                    observations: null,
                },
	        	errors: {},
                employee_loading: false,
                employees: [],
                employees_from_db: [],
                last_employee_search: null,
                downloadUrl: null,
                registerFormVisible: false,
                registerForm: {
                    permission: {},
                    status: false
                },
                uploadFilesFormVisible: false,
                uploadFilesForm: {
                    permission: {},
                    status: false
                },
                filesTableLoading: false,
                rules: {
                    status: [
                        { validator: validateStatus, required: true, _message: 'Debe seleccionar la opción "Registrado"', trigger: 'change' },
                    ]
                },
                headers:{
                    'Authorization': 'Bearer ' + localStorage.getItem('id_token'),
                    'X-Requested-With': 'XMLHttpRequest'
                },
                filters: {},
            };
        },
        components: {
            'filters-form': filters_form,
            'el-crud': el_crud,
        },
        mounted() {
            this.setDownloadUrl();
            this.fetchExcuses();
        },
        computed: {
            ...mapGetters(["excuses"]),
            'permission_date': function () {
                if (this.registerForm.permission.datetime_from) {
                    return moment(this.registerForm.permission.datetime_from).format('YYYY-MM-DD');
                } else {
                    return null;
                }
            },
            'permission_hours': function () {
                if (this.registerForm.permission.datetime_from) {
                    return moment(this.registerForm.permission.datetime_from).format('HH:mm') + ' a ' + moment(this.registerForm.permission.datetime_to).format('HH:mm');
                } else {
                    return null;
                }
            },
        },
        watch: {
            '$route': function (to) {
                this.setDownloadUrl();
            }
        },
        methods: {
            ...mapActions(["fetchExcuses"]),
            onFiltersSubmited(filters) {
                // console.log(filters);
                this.filters = filters;
            },
            handleCheck (idx, data) {
                this.registerForm.permission = {
                    id: data.id,
                    employee_id: data.employee_id,
                    employee_id_number: data.employee_id_number,
                    employee_name: data.employee_name,
                    employee_title: data.employee_title,
                    datetime_from: data.datetime_from,
                    datetime_to: data.datetime_to,
                    observations: data.observations,
                    updated_by: data.updated_by,
                    status: data.status,
                };
                this.registerFormVisible = true;
            },
            handleItemsFetched () {
                // console.log('items fetched');
                // console.log(this.$refs['crud'].$refs['dataTable'].data);
                // console.log(this.uploadFilesForm.permission.id);
                if (this.uploadFilesFormVisible && this.uploadFilesForm.permission.id != undefined) {
                    const row = _.find(this.$refs['crud'].$refs['dataTable'].data, (elem) => elem.id == this.uploadFilesForm.permission.id);
                    if (row) {
                        this.handleDocument(0, row);
                    }
                }
                this.filesTableLoading = false;
            },
            handleDocument (idx, data) {
                this.registerForm.permission = {
                    id: data.id,
                    employee_id: data.employee_id,
                    employee_id_number: data.employee_id_number,
                    employee_name: data.employee_name,
                    employee_title: data.employee_title,
                    datetime_from: data.datetime_from,
                    datetime_to: data.datetime_to,
                    observations: data.observations,
                    updated_by: data.updated_by,
                    status: data.status,
                };
                this.uploadFilesForm.permission = {
                    id: data.id,
                    files: data.files,
                    employee_id: data.employee_id,
                    employee_id_number: data.employee_id_number,
                    employee_name: data.employee_name,
                    employee_title: data.employee_title,
                    datetime_from: data.datetime_from,
                    datetime_to: data.datetime_to,
                    observations: data.observations,
                    updated_by: data.updated_by,
                    status: data.status,
                };
                this.filesTableLoading = false;
                this.uploadFilesFormVisible = true;
            },
            submitUpload() {
                this.$refs.upload.submit();
                this.filesTableLoading = true;
            },
            uploadSuccess(response, file, fileList) {
                this.$refs.upload.clearFiles();
                this.$refs['crud'].refresh();
                // this.uploadFilesFormVisible = false;
                // this.uploadFilesForm.permission = {};
                this.$notify({
                    title: 'Operación exitosa',
                    message: 'El archivo se agregó exitosamente',
                    type: 'success'
                });
            },
            downloadFile(id) {
                window.location.href = '/api/permissions/'+this.uploadFilesForm.permission.id+'/files/'+id+'?token='+localStorage.getItem('id_token');
            },
            removeFile(id) {
                // console.log(id);
                this.uploadFilesForm.permission.files = _.filter(this.uploadFilesForm.permission.files, (elem) => elem.id != id);
                axios.delete('/api/permissions/'+this.uploadFilesForm.permission.id+'/files/'+id).then((response) => {
                    // console.log(response);
                    // this.$router.push(self.baseUrl);
                    this.$notify({
                        title: 'Operación exitosa',
                        message: 'El archivo se eliminó exitosamente',
                        type: 'success'
                    });
                    this.$refs['crud'].refresh();
                }).catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: (error.response.data.message)
                    });
                });
            },
        	clearErrors() {
	        	_.each(this.errors, (val, field) => {
	        		this.errors[field] = null;
	        	});
			},
            handleRegister () {
                // console.log(this.registerForm);

                this.$refs['registerForm'].validate((valid) => {
					if (valid) {

						this.clearErrors();

                        const data = {
                            employee_id: this.registerForm.permission.employee_id
                        };

                        axios.patch('/api/permissions/' + this.registerForm.permission.id + '/registerusage', data)
                        .then((response) => {
                            // console.log(response);
                            this.$notify({
                                title: 'Operación exitosa',
                                message: 'La modificación se procesó exitosamente',
                                type: 'success'
                            });
                            this.registerFormVisible = false;
                            this.$refs['crud'].refresh();
                        })
                        .catch((error) => {
                            this.formLoading = false;
                            // console.log(error.response);
                            if (error.response.status == 422) {
                                _.each(error.response.data, (value, key) => {
                                    this.errors[key] = value.join(', ');
                                });
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: (error.response.data.message)
                                });
                            }
                        });
                    }
                });
            },
            setDownloadUrl: function () {
                // console.log(this.$route);
                this.queryString = $.param(this.$route.query);
                if (this.$route.query.date_from != undefined 
                    && this.$route.query.date_to != undefined 
                    && this.$route.query.date_from != null 
                    && this.$route.query.date_to != null) {
                // if (this.$route.query.date != undefined 
                //     && this.$route.query.date != null) {
                    this.downloadUrl = '/api/permissions/download?'+this.queryString;
                } else {
                    this.downloadUrl = null;
                }
            },
            downloadReport: function () {
                if (this.downloadUrl != null) {
                    window.location.href = this.downloadUrl+'&token='+localStorage.getItem('id_token');
                }
            },
            dateRangePickerChange () {
                let value = this.filters.date_range;
                // console.log(value);
                this.filters.date_from = moment(value[0]).format('YYYY-MM-DD');
                this.filters.date_to = moment(value[1]).format('YYYY-MM-DD');
            },
            datePickerChange () {
                this.timeFromPickerChange();
                this.timeToPickerChange();
            },
            timeFromPickerChange () {
                const date = moment(this.resource.date.value);
                this.resource.datetime_from.value = moment(this.time_from).year(date.year()).month(date.month()).date(date.date()).second(0);
                // this.time_from = this.resource.datetime_from.value.format('YYYY-MM-DD HH:mm:ss');
                // console.log(this.resource.datetime_from.value);
            },
            timeToPickerChange () {
                const date = moment(this.resource.date.value);
                if (this.resource.end_record_date.value == 'next_day') {
                    date.add(1, 'd');
                }
                this.resource.datetime_to.value = moment(this.time_to).year(date.year()).month(date.month()).date(date.date()).second(0);
                // this.time_to = this.resource.datetime_to.value.format('YYYY-MM-DD HH:mm:ss');
            },
            employeeSearch (query) {
                query = query.toUpperCase();
                if (query.length > 2) {
                    this.employee_loading = true;
                    if (this.last_employee_search !== null && query.indexOf(this.last_employee_search) == 0) {
                        var emp = [];
                        _.each(this.employees_from_db, (item) => {
                            if (item.id_number.toUpperCase().indexOf(query) >= 0 || item.last_name.toUpperCase().indexOf(query) >= 0 || item.first_name.toUpperCase().indexOf(query) >= 0) {
                                emp.push({label: item.id_number + ' - ' + item.last_name + ', ' + item.first_name, value: item.id});
                            }
                        });
                        this.employees = emp;
                        this.employee_loading = false;

                        // this.employees = this.employees_from_db.filter(item => {
                        //     return 
                        // });
                    } else {
                        let query_string = `?filter=${query}`;
                        if (this.filters.functional_area_id != null) {
                            query_string += `&functional_area_id=${this.filters.functional_area_id}`;
                        }
                        if (this.filters.roster_id != null) {
                            query_string += `&functional_area_id=${this.filters.roster_id}`;
                        }
                        axios.get('/api/employees' + query_string).then((response) => {
                            this.employees_from_db = [];
                            var emp = [];
                            _.each(response.data.data, (item) => {
                                this.employees_from_db.push({id: item.id, id_number: item.id_number, last_name: item.last_name, first_name: item.first_name}); 
                                emp.push({label: item.id_number + ' - ' + item.last_name + ', ' + item.first_name, value: item.id});
                            });
                            this.employees = emp;
                            this.employee_loading = false;
                        });
                        this.last_employee_search = query;
                    }
                } else {
                    this.employees = [];
                }
            }
        }
    }
</script>
